import React from 'react';
import PropTypes from 'prop-types';

import { DATE_FORMAT, formatDate } from 'helpers/formatters/date_time_formats';
import { USD } from 'helpers/formatters/number_formats';
import { values } from './config';

export default function DealValue({ deal, name, value, valueConfig, onClick }) {
  if (value == null && deal) {
    value = deal[name];
  }

  const config = values[name] || valueConfig;
  if (config) {
    if (config.component && deal) {
      const Component = config.component;
      return <Component deal={deal} name={name} onClick={onClick} />;
    }

    if (config.currency && value != null) {
      value = USD.format(value, { round: config.round });
    }

    if (typeof value === 'number' && config.format !== false) {
      value = value.toLocaleString();
    }

    if (config.date && value != null) {
      value = formatDate(typeof value === 'string' ? value : value.date, DATE_FORMAT);
    }

    if (config.percentage && value != null) {
      value = value + '%';
    }
  }

  return value || '';
}

DealValue.propTypes = {
  deal: PropTypes.shape({
    path: PropTypes.string,
    tasks: PropTypes.array
  }),
  name: PropTypes.string,
  value: PropTypes.any,
  valueConfig: PropTypes.object,
  onClick: PropTypes.func,
};
